/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { Button } from "../../../general/Button/Button";

export const TryAgain: React.FC<{ onClick: () => void; isVisible: boolean; text: string }> = ({
  onClick,
  isVisible,
  text,
}) => {
  if (!isVisible) {
    return null;
  }
  return (
    <Button
      onClick={onClick}
      buttonType="primary"
      textSize={"Large"}
      css={css`
        border-radius: 14px;
        height: 56px;
        width: 341px;
        cursor: pointer;
        justify-content: center;
      `}
      text={text}
    />
  );
};
